import { atom } from "jotai";

export const respuestaConsultaAbiertaAtom = atom([]);
export const detallesConsultaAtom = atom([]);
export const consultaSeleccionadaAtom = atom();
